import React from 'react';
export const ContextUser = React.createContext({ user: undefined });
